module.exports = __webpack_public_path__ + "img/banner2.9c9c7327.png";